import * as React from 'react';
import { connect } from 'react-redux';
import { IApplicationState } from '../../store';
import { SurveyNotesActionCreators } from '../../store/SurveyNotesActionCreators';
import { SurveyNoteHeader } from './SurveyNoteHeader';

export const SurveyNoteHeaderContainer: React.ComponentType<any> = connect(
	(state: IApplicationState, props: { withoutContainer?: boolean }) => ({ ...state.surveyBuilder, ...props }),
	{
		...SurveyNotesActionCreators,
	},
)(SurveyNoteHeader);
